import { render, staticRenderFns } from "./ListThumbView.vue?vue&type=template&id=195922c4&"
import script from "./ListThumbView.vue?vue&type=script&lang=js&"
export * from "./ListThumbView.vue?vue&type=script&lang=js&"
import style0 from "./ListThumbView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports